import classNames from 'classnames';
import * as React from 'react';

import { EBrandingLevel } from '../../types/offer';
import * as styles from './BrandingLevelWrapper.css';

interface IBrandingLevelWrapperProps {
  brandingLevel: EBrandingLevel | null;
}

export const BrandingLevelWrapper: React.FC<IBrandingLevelWrapperProps> = ({ brandingLevel, children }) => {
  const className = classNames(styles['branding-level-wrapper'], {
    [styles['platinum']]: brandingLevel === EBrandingLevel.ThirdLevel,
  });

  return <div className={className}>{children}</div>;
};
